module.exports = __FOREMAN_VENDOR__CORE_JS_SHIM__;